/**
 * Reusable dice button component
 * Displays a clickable dice icon for rolling initiative or other dice actions
 */

interface DiceButtonProps {
  onClick: () => void;
  title?: string;
  size?: number;
  disabled?: boolean;
}

/**
 * Compact circular dice button with hover effects
 * Used in initiative panel and anywhere a quick roll button is needed
 */
export function DiceButton({ onClick, title = 'Roll', size = 24, disabled = false }: DiceButtonProps) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      title={title}
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: 'var(--color-primary)',
        border: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        transition: 'all 0.15s ease',
        fontSize: size * 0.5,
      }}
      onMouseEnter={(e) => {
        if (!disabled) {
          e.currentTarget.style.transform = 'scale(1.1)';
          e.currentTarget.style.boxShadow = '0 0 8px var(--color-primary)';
        }
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
        e.currentTarget.style.boxShadow = 'none';
      }}
    >
      🎲
    </button>
  );
}
